module.exports = __webpack_public_path__ + "img/filteredit.f25310b2.svg";